/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `pending` - Oczekuje na zatwierdzenie
 * * `approved` - Zatwierdzone
 * * `executing` - W trakcie wykonania
 * * `completed` - Zakończone
 * * `failed` - Nieudane
 * * `rejected` - Odrzucone
 * * `withdrawn` - Wycofane
 * * `expired` - Wygasłe
 */
export type BulkRequestStatusEnum = typeof BulkRequestStatusEnum[keyof typeof BulkRequestStatusEnum];


export const BulkRequestStatusEnum = {
  pending: 'pending',
  approved: 'approved',
  executing: 'executing',
  completed: 'completed',
  failed: 'failed',
  rejected: 'rejected',
  withdrawn: 'withdrawn',
  expired: 'expired',
} as const;
